import { Row, Col } from 'reactstrap';
import GoBackToListButton from '../../../../../components/buttons/GoBackToListButton';
import { PathsLayouts } from '../../../../../config/routes';
import { DetailBox } from '@octano/global-ui';
import { useTexts } from '../hooks/useTexts';

type Props = {
  classRoomInfo: {
    name: string;
    code: string;
    type: string;
    school: string;
  };
};

export const ClassroomBox = ({ classRoomInfo }: Props) => {
  const texts = useTexts();
  return (
    <Row className="d-flex justify-content-between align-items-center mt-2">
      <Col xs={12} md={6} lg={3}>
        <GoBackToListButton path={PathsLayouts.classrooms} />
      </Col>
      <Col xs={12} md={6} lg={5}>
        <DetailBox
          columns={[
            {
              title: texts.classroomDetailBox.classroomName,
              body: classRoomInfo.name,
              size: { xs: 12, md: 3 },
            },
            {
              title: texts.classroomDetailBox.code,
              body: classRoomInfo.code,
              size: { xs: 12, md: 3 },
            },
            {
              title: texts.classroomDetailBox.classroomType,
              body: classRoomInfo.type,
              size: { xs: 12, md: 3 },
            },
            {
              title: texts.classroomDetailBox.school,
              body: classRoomInfo.school,
              size: { xs: 12, md: 3 },
            },
          ]}
        />
      </Col>
    </Row>
  );
};
